import { createSelector, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { GetAllDivisionsResponse, Division, substitutionsApi } from 'app/services/edpApiV1/substitutions';
import { RootState } from 'app/store';

type ISubstitutionSlice = {
  data: Division[] | null;
  pagination: {
    size: number;
    page: number;
    total: number;
  };
};

const initialState: ISubstitutionSlice = {
  data: null,
  pagination: {
    size: 10,
    page: 1,
    total: 0,
  },
};

export const substitutionSlice = createSlice({
  name: 'substitution',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addMatcher(
        substitutionsApi.endpoints.getAllDivisions.matchFulfilled,
        (state, { payload }: PayloadAction<GetAllDivisionsResponse>) => payload,
      )
      .addMatcher(substitutionsApi.endpoints.getAllDivisions.matchRejected, () => initialState);
  },
});

const substitutions = (state: RootState) => state.entities.substitutions;
const getSubstitutions = createSelector(substitutions, state => state);

export const selectors = { getSubstitutions };
export const actions = substitutionSlice.actions;
export const reducer = substitutionSlice.reducer;
